<template>
  <div class="description text-uppercase">
    <strong v-if="recommendedAccessory">
      {{ $resourceString["product.detail.recommended.weldrods"] }}
    </strong>

    <ul class="list-unstyled" v-if="recommendedAccessory">
      <li class="weldrods">
        <a href="javascript:void(0)" @click="openWeldrodsModal">
          {{ formatAccessory(recommendedAccessory) }}
        </a>
      </li>
    </ul>

    <modal
      height="560"
      name="recommended-weldrods-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <pc-product-weldrods-modal
        :recommendedAccessory="recommendedAccessory"
      />
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PCWeldRodsModal from "./pc-product-weldrods-modal.vue";

export default {
  props: ["specification"],
  components: {
    "pc-product-weldrods-modal": PCWeldRodsModal,
  },
  computed: {
    ...mapGetters({
      selectedColor: "productDetail/color",
      productData: "productDetail/productData",
    }),
    recommendedAccessory() {
      if (!this.productData?.colors) {
        return "";
      }
      const color = this.productData.colors.find(
        (c) => c.colorNumber === this.selectedColor.colorNumber
      );
      if (!color?.recommendedAccessories?.length) {
        return "";
      }

      let accessory = color.recommendedAccessories[0];
      if (!accessory) {
        return "";
      }
      return accessory;
    },
  },
  methods: {
    formatAccessory(acc) {
      return (
        this.$resourceString["product.detail.recommended.weldrod"] +
        " " +
        acc.accesoryStyleNumber +
        " - " +
        " " +
        acc.accesoryColorName +
        " " +
        acc.accesoryColorNumber
      );
    },
    openWeldrodsModal() {
      this.$modal.show("recommended-weldrods-modal");
    },
  },
};
</script>
